/* eslint-disable */
/**
 * Pattern Cropper — modal + Cropper.js wrapper for is_mto products
 * in the wallpaper category (category_id = 89).
 *
 * Activates only when window.PATTERN_CROPPER.enabled is true.
 * Reads width/height in cm from the customer's selected option inputs.
 * On confirm: writes a JSON payload into #input-crop-data then continues
 * the original add-to-cart flow.
 */

import Cropper from 'cropperjs';
import cropperCss from 'cropperjs/dist/cropper.min.css';

const MODAL_ID = 'pattern-cropper-modal';
let cropperInstance = null;
let cssInjected = false;
let modalEl = null;
let resolveFn = null;
// Visual-aid overlays — toggled by the modal buttons. Re-rendered on every
// Cropper.js `crop` event so they track the live crop-box position.
let showHuman = false;
let showRuler = false;

// 175 cm silhouette SVG (anchored to its bottom — stands on the wall floor).
// Vector silhouette extracted from a licensed Shutterstock EPS asset
// (#2231215375) — slender standing woman in summer dress. PostScript path
// converted to SVG via a one-off Python script; tight viewBox computed from
// the path bounding box. Filled with even-odd rule so the chest detail
// reads as an inner negative space.
const HUMAN_SVG = `
<svg viewBox="1452 436 1091 3412" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMax meet" style="display:block; width:100%; height:100%;">
    <path fill="#1f2937" fill-opacity="0.9" fill-rule="evenodd" d="M2249.96 1935.52C2247.2 1967.23 2241.98 1990.74 2238.23 2019.79C2229.97 1951.84 2221.05 1883 2210.71 1833.31C2209.58 1827.21 2208.3 1821.41 2206.85 1815.97C2205.88 1811.91 2204.9 1807.97 2203.91 1804.28C2203.58 1803.07 2203.15 1801.78 2202.67 1800.45C2182.98 1725.47 2162.98 1608.53 2171.67 1569.43C2180.88 1527.98 2240.75 1403.65 2240.75 1403.65C2240.75 1403.65 2229.23 1500.35 2222.33 1539.49C2215.42 1578.64 2217.72 1594.75 2226.93 1682.25C2236.14 1769.75 2254.56 1882.57 2249.96 1935.52ZM2542.76 3813.79C2542.16 3791.18 2537.62 3774.14 2526.06 3702.5C2514.55 3631.12 2496.9 3583.73 2489.42 3548.23C2481.93 3512.73 2478.04 3461.88 2473.08 3420.34C2468.12 3378.81 2427.51 3115.88 2407.25 3014.61C2387 2913.34 2355.39 2843.69 2335.14 2793.05C2319.31 2753.5 2312.32 2717.84 2310.02 2704.11C2311.5 2702.83 2334.17 2694.14 2334.06 2692.64C2332.22 2666.95 2299.7 2460.07 2270.84 2277.19C2272.45 2277.57 2274.28 2277.72 2276.43 2277.59C2290.25 2276.73 2291.29 2269.29 2291.98 2252.12C2292.41 2241.32 2292.84 2229.67 2291.11 2207.22C2289.39 2184.77 2286.8 2166.64 2288.52 2174.41C2290.25 2182.18 2300.61 2204.63 2302.34 2234.85C2304.06 2265.07 2288.29 2272.53 2291.54 2288.81C2292.84 2295.29 2300.64 2296.85 2316.58 2289.68C2333.85 2281.91 2339.46 2268.52 2339.46 2268.52C2339.46 2268.52 2347.24 2271.11 2359.32 2266.8C2371.41 2262.48 2367.1 2226.21 2367.38 2223.34C2367.38 2223.34 2378.63 2220.41 2381.77 2214.13C2385.09 2207.49 2384.33 2201.82 2382.62 2181.55C2383.31 2160.07 2381.56 2130.12 2371.41 2118.29C2357.6 2102.17 2325.94 2048.35 2328.24 2002.3C2330.54 1956.25 2337.45 1845.73 2344.36 1765.14C2351.26 1684.55 2358.17 1594.75 2351.26 1551.01C2344.36 1507.26 2348.96 1435.88 2362.78 1396.74C2376.59 1357.6 2399.62 1260.89 2411.13 1150.37C2420.68 1058.65 2407.21 1017.28 2371.99 993.803C2347.35 977.379 2300.62 968.736 2260.68 964.198C2259.68 947.595 2257.49 925.988 2252.86 901.703C2242.31 846.443 2228.83 816.229 2221.49 763.979C2213.86 709.614 2212.61 650.192 2195.74 601.84C2178.87 553.487 2151.62 496.464 2107.32 466.532C2063.03 436.6 2010.3 443.507 2010.3 443.507C2010.3 443.507 1972.33 436.6 1932.26 480.346C1892.18 524.094 1860.54 570.144 1854.22 613.892C1847.89 657.64 1835.23 712.899 1826.8 788.881C1818.36 864.864 1824.69 961.569 1818.36 1000.71C1818.01 1002.89 1817.76 1005.03 1817.56 1007.14C1778.28 1024.51 1750 1036.1 1741.1 1060.58C1731.89 1085.9 1733.39 1171.1 1740.29 1258.59C1745.83 1328.65 1761.08 1380.97 1758.34 1423.88C1750.34 1505.05 1727.45 1598.2 1711.17 1651.75C1676.12 1767.09 1668.48 1814.98 1640.85 1932.4C1613.22 2049.83 1587.76 2242.51 1569.34 2293.17C1550.92 2343.82 1464.68 2572.86 1457.46 2596.21C1452.77 2611.4 1513.67 2626.41 1513.67 2626.41C1513.67 2626.41 1508.33 2640 1506.49 2649.03C1504.27 2659.94 1564.32 2644.83 1587.35 2649.43C1597.66 2651.5 1624.44 2657.18 1672.41 2666.65C1667.35 2711.89 1659.01 2796.82 1660.11 2855.86C1661.64 2937.57 1665.89 3017.81 1683.73 3163.09C1701.58 3308.38 1719.75 3443.85 1723.2 3492.97C1726.66 3542.09 1730.11 3573.56 1716.3 3631.12C1702.48 3688.68 1679.46 3714.97 1679.46 3735.69C1679.46 3756.42 1681.76 3777.14 1711.69 3784.04C1741.62 3790.95 1783.07 3795.56 1803.79 3784.04C1824.51 3772.53 1831.42 3754.11 1831.42 3738C1831.42 3721.88 1833.72 3708.06 1833.72 3708.06L1842.93 3705.76C1842.93 3705.76 1842.93 3591.98 1845.24 3580.47C1847.54 3568.95 1863.66 3548.23 1845.24 3511.39C1834.12 3489.16 1820.67 3459.69 1815.97 3442.18C1811.27 3424.66 1816.01 3353.72 1818.82 3324.05C1821.64 3294.38 1832.75 3191.13 1842.94 3068.79C1853.14 2946.44 1833.72 2853.07 1844.31 2793.51C1849.26 2765.7 1859.82 2720.26 1866.07 2694.06C1882.73 2696.27 1898.25 2698.27 1912.01 2699.95C1969.65 2707.01 2004.99 2715.27 2116.06 2717.36C2120.65 2741.54 2131.87 2793.24 2152.2 2844.99C2180.05 2915.88 2202.88 2938.87 2209.78 2991.83C2221.17 3079.29 2285.73 3201.96 2318.64 3275.38C2334.12 3309.9 2347.31 3343.81 2357.25 3374.31C2361.1 3397.03 2371.57 3462.38 2369.69 3490.67C2367.38 3525.21 2383.31 3574.71 2385.61 3595.05C2387.91 3615.39 2390.41 3665.66 2385.8 3716.31C2381.2 3766.97 2387.91 3788.65 2387.91 3788.65L2399.62 3790.95C2399.62 3790.95 2397.32 3839.3 2408.83 3843.91C2420.34 3848.51 2500.74 3848.51 2519.16 3843.91C2537.58 3839.3 2543.33 3835.66 2542.76 3813.79Z"/>
</svg>`;

/**
 * Custom CSS overrides injected once per page lifetime so the Cropper.js
 * canvas reads as a "wall" preview — light bleed outside the crop instead
 * of the default dark dim, dotted purple border on the selection, and
 * hidden resize handles (we lock the crop box anyway).
 */
const PATTERN_CROPPER_OVERRIDES = `
#${MODAL_ID} .cropper-container { background: #e9ecef; }
/* Outside the crop box: a soft light overlay so the pattern image bleeds
   through at ~18%. Combined with the canvas-sizing logic in
   centerCropBoxAndCanvas (matches one of the box's dimensions exactly), the
   bleed only ever appears on the two perpendicular sides — never all four. */
#${MODAL_ID} .cropper-modal {
    background-color: #f3f4f6 !important;
    opacity: 0.82 !important;
}
#${MODAL_ID} .cropper-view-box {
    outline: none !important;
    box-shadow: 0 0 0 1.5px rgba(31, 41, 55, 0.55), inset 0 0 0 1px rgba(255,255,255,0.15);
}
#${MODAL_ID} .cropper-dashed { display: none !important; }
#${MODAL_ID} .cropper-center  { display: none !important; }
#${MODAL_ID} .cropper-line,
#${MODAL_ID} .cropper-point   { display: none !important; }
#${MODAL_ID} .cropper-face    { background-color: transparent !important; cursor: grab; }
#${MODAL_ID} .cropper-face:active { cursor: grabbing; }
/* Dotted overlay drawn on top of the view-box edge */
#${MODAL_ID} .cropper-view-box::after {
    content: ''; position: absolute; inset: 0;
    border: 1.5px dashed rgba(31, 41, 55, 0.85);
    pointer-events: none;
}
/* Tool list — two-column grid; each cell is icon + label */
#${MODAL_ID} .pc-tool-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px 10px;
}
#${MODAL_ID} .pc-tool-row {
    display: flex; align-items: center; gap: 10px;
    padding: 6px 10px; border-radius: 8px;
    background: transparent; border: 1px solid #e5e7eb;
    color: #374151; text-align: left; cursor: pointer;
    transition: background .15s ease, border-color .15s ease;
    font-size: 12px; line-height: 1.2;
    min-width: 0;
}
#${MODAL_ID} .pc-tool-row:hover {
    background: #f9fafb; border-color: #e5e7eb;
}
#${MODAL_ID} .pc-tool-row:hover .pc-tool-btn {
    border-color: #7c3aed; color: #7c3aed;
}
#${MODAL_ID} .pc-tool-btn {
    flex: 0 0 auto;
    width: 36px; height: 36px; border-radius: 50%;
    background: #fff; border: 1px solid #d1d5db; color: #374151;
    display: inline-flex; align-items: center; justify-content: center;
    font-size: 14px; transition: all .15s ease;
}
#${MODAL_ID} .pc-tool-row.active .pc-tool-btn {
    background: #7c3aed; border-color: #7c3aed; color: #fff;
}
#${MODAL_ID} .pc-tool-row.active {
    background: #faf5ff; border-color: #e9d5ff;
}
#${MODAL_ID} .pc-tool-row.active .pc-tool-name {
    color: #7c3aed; font-weight: 600;
}
#${MODAL_ID} .pc-tool-name {
    color: inherit; user-select: none;
    flex: 1 1 auto; min-width: 0;
    overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}
#${MODAL_ID} .pc-card {
    background: #fff; border: 1px solid #e5e7eb; border-radius: 12px;
    padding: 20px 24px; height: 100%;
    box-shadow: 0 1px 3px rgba(15,23,42,0.04), 0 1px 2px rgba(15,23,42,0.06);
    transition: box-shadow .2s ease;
}
#${MODAL_ID} .pc-card:hover {
    box-shadow: 0 4px 10px rgba(15,23,42,0.06), 0 2px 4px rgba(15,23,42,0.08);
}
#${MODAL_ID} .pc-card-label {
    font-size: 11px; font-weight: 700; color: #6b7280;
    text-transform: uppercase; letter-spacing: .8px;
    margin-bottom: 12px;
    display: flex; align-items: center; gap: 6px;
}
#${MODAL_ID} .pc-cards-row {
    row-gap: 16px !important;
    padding: 20px !important;
}
/* Back button — floats over the top-left of the cropper stage */
#${MODAL_ID} .pc-back-btn {
    position: absolute; top: 25px; left: 25px; z-index: 20;
    width: 44px; height: 44px; border-radius: 50%;
    background: #fff; border: 1px solid #e5e7eb;
    color: #374151; font-size: 16px;
    display: inline-flex; align-items: center; justify-content: center;
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(15,23,42,0.06), 0 1px 2px rgba(15,23,42,0.08);
    transition: all .15s ease;
}
#${MODAL_ID} .pc-back-btn:hover {
    border-color: #7c3aed; color: #7c3aed;
    box-shadow: 0 4px 10px rgba(15,23,42,0.08), 0 2px 4px rgba(15,23,42,0.1);
}
`;

/**
 * Generate ruler tick HTML for a wall edge of length `lengthCm`.
 * @param {string} axis  'h' for top (width) or 'v' for right (height)
 * @param {number} lengthCm  total wall length in centimetres
 * @param {number} boxPx     pixel length of the crop-box edge
 * @returns {string} absolutely-positioned tick markup
 */
function buildRulerTicks(axis, lengthCm, boxPx) {
    if (!lengthCm || !boxPx) return '';
    // Choose an interval that keeps ~6-12 ticks: 25 / 50 / 100 cm.
    let interval = 25;
    if (lengthCm > 300) interval = 100;
    else if (lengthCm > 150) interval = 50;
    let out = '';
    for (let cm = 0; cm <= lengthCm; cm += interval) {
        const frac = cm / lengthCm; // 0..1
        const px = frac * boxPx;
        const isMajor = (cm % (interval * 2) === 0) || cm === lengthCm;
        if (axis === 'h') {
            // Top ruler — tick goes down from the top edge
            out += `<div style="position:absolute; left:${px}px; top:0; width:1px; height:${isMajor ? 10 : 6}px; background:#1f2937;"></div>`;
            if (isMajor) {
                out += `<div style="position:absolute; left:${px}px; top:11px; transform:translateX(-50%); font-size:10px; line-height:1; color:#1f2937; font-weight:600; white-space:nowrap; background:rgba(255,255,255,0.92); padding:0 4px; border-radius:3px;">${cm}</div>`;
            }
        } else {
            // Right ruler — tick goes left from the right edge
            out += `<div style="position:absolute; right:0; top:${px}px; width:${isMajor ? 10 : 6}px; height:1px; background:#1f2937;"></div>`;
            if (isMajor) {
                out += `<div style="position:absolute; right:11px; top:${px}px; transform:translateY(-50%); font-size:10px; line-height:1; color:#1f2937; font-weight:600; white-space:nowrap; background:rgba(255,255,255,0.92); padding:0 4px; border-radius:3px;">${cm}</div>`;
            }
        }
    }
    return out;
}

/**
 * Reposition + redraw the wall-preview overlays based on the current
 * crop-box rectangle and the customer's selected wall dimensions (cm).
 *
 * Always-on overlays: dimension pills (top + left), corner diagonal lines
 * that hint at a 3D wall extending beyond the crop.
 * Toggleable overlays: human silhouette (175cm), ruler ticks (cm).
 *
 * Called from Cropper's `ready` / `crop` events and from toggle handlers.
 */
function renderOverlays() {
    if (!modalEl || !cropperInstance) return;
    const stage = modalEl.querySelector('#' + MODAL_ID + '-stage');
    if (!stage) return;

    // Lookup or lazy-create the overlay layer (positioned over the stage).
    let layer = stage.querySelector('[data-pc-overlay-layer]');
    if (!layer) {
        layer = document.createElement('div');
        layer.setAttribute('data-pc-overlay-layer', '');
        layer.style.cssText = 'position:absolute; left:0; top:0; right:0; bottom:0; pointer-events:none; z-index:5; overflow:visible;';
        stage.style.position = 'relative';
        stage.appendChild(layer);
    }
    layer.innerHTML = '';

    // Crop box position is given in pixels relative to the cropper-container,
    // which has the same content box as the stage in our setup.
    let box;
    try { box = cropperInstance.getCropBoxData(); } catch (e) { return; }
    if (!box || !box.width || !box.height) return;

    const widthCm  = parseFloat(modalEl.dataset.widthCm  || '0') || 0;
    const heightCm = parseFloat(modalEl.dataset.heightCm || '0') || 0;
    const widthRaw  = parseFloat(modalEl.dataset.widthRaw  || '0') || widthCm;
    const heightRaw = parseFloat(modalEl.dataset.heightRaw || '0') || heightCm;
    const dimUnit   = modalEl.dataset.dimUnit || 'cm';

    // -------- Corner diagonal lines (3D wall hint) --------
    // Drawn as a single absolute-positioned SVG so they can extend OUTSIDE
    // the crop box without being clipped.
    const diagLen = 60;
    const cornerSvg = `
        <svg style="position:absolute; left:0; top:0; width:100%; height:100%; overflow:visible; pointer-events:none;">
            <g stroke="rgba(31,41,55,0.5)" stroke-width="1" stroke-dasharray="3 3" fill="none">
                <line x1="${box.left}"             y1="${box.top}"               x2="${box.left - diagLen}"             y2="${box.top - diagLen}"/>
                <line x1="${box.left + box.width}" y1="${box.top}"               x2="${box.left + box.width + diagLen}" y2="${box.top - diagLen}"/>
                <line x1="${box.left}"             y1="${box.top + box.height}"  x2="${box.left - diagLen}"             y2="${box.top + box.height + diagLen}"/>
                <line x1="${box.left + box.width}" y1="${box.top + box.height}"  x2="${box.left + box.width + diagLen}" y2="${box.top + box.height + diagLen}"/>
            </g>
        </svg>`;
    const corners = document.createElement('div');
    corners.innerHTML = cornerSvg;
    layer.appendChild(corners);

    // -------- Dimension pills (always shown) --------
    if (widthCm > 0) {
        const pillTop = document.createElement('div');
        pillTop.style.cssText = `position:absolute; left:${box.left + box.width / 2}px; top:${box.top - 18}px; transform:translate(-50%, -50%); background:#fff; border:1px solid #d1d5db; border-radius:14px; padding:3px 12px; font-size:11px; font-weight:600; color:#374151; white-space:nowrap; box-shadow:0 1px 2px rgba(0,0,0,0.06);`;
        pillTop.textContent = widthRaw + ' ' + dimUnit;
        layer.appendChild(pillTop);
    }
    if (heightCm > 0) {
        const pillSide = document.createElement('div');
        pillSide.style.cssText = `position:absolute; left:${box.left - 18}px; top:${box.top + box.height / 2}px; transform:translate(-50%, -50%) rotate(-90deg); background:#fff; border:1px solid #d1d5db; border-radius:14px; padding:3px 12px; font-size:11px; font-weight:600; color:#374151; white-space:nowrap; box-shadow:0 1px 2px rgba(0,0,0,0.06);`;
        pillSide.textContent = heightRaw + ' ' + dimUnit;
        layer.appendChild(pillSide);
    }

    // -------- Human silhouette (toggle) --------
    // Placed flush to the RIGHT EDGE of the crop box, bottom-aligned.
    // Height scales so 175cm maps to (175/heightCm) of the crop-box pixel height.
    // The SVG path has a 1091×3412 bounding box (≈0.32 aspect) — a slender
    // standing figure, narrower than the rectangle would suggest.
    if (showHuman && heightCm > 0) {
        const humanHpx = box.height * (175 / heightCm);
        const humanWpx = humanHpx * (1091 / 3412); // tight SVG viewBox ratio
        const left = box.left + box.width + 12;
        const top  = box.top + box.height - humanHpx;
        const human = document.createElement('div');
        human.style.cssText = `position:absolute; left:${left}px; top:${top}px; width:${humanWpx}px; height:${humanHpx}px;`;
        // 175cm label printed near the waist (~50% of the figure height).
        const labelTop = humanHpx * 0.5;
        human.innerHTML = HUMAN_SVG + `<div style="position:absolute; left:50%; top:${labelTop}px; transform:translate(-50%, -50%); font-size:11px; color:#fff; font-weight:700; white-space:nowrap; pointer-events:none; letter-spacing:.3px;">175 cm</div>`;
        layer.appendChild(human);
    }

    // -------- Ruler (toggle) — tick marks along top + right edges --------
    if (showRuler) {
        const ruler = document.createElement('div');
        ruler.style.cssText = `position:absolute; left:${box.left}px; top:${box.top}px; width:${box.width}px; height:${box.height}px;`;
        ruler.innerHTML =
            buildRulerTicks('h', widthCm,  box.width)
          + buildRulerTicks('v', heightCm, box.height);
        layer.appendChild(ruler);
    }
}

function injectCss() {
    if (cssInjected) return;
    const style = document.createElement('style');
    // cropper.min.css imported as a string by webpack — we keep both paths working
    style.textContent = typeof cropperCss === 'string' ? cropperCss : (cropperCss && cropperCss.default ? cropperCss.default : '');
    // Fallback raw inline if the bundler returned an object/module
    if (!style.textContent) {
        style.textContent = '.cropper-container{-webkit-touch-callout:none;direction:ltr;font-size:0;line-height:0;position:relative;-ms-touch-action:none;touch-action:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.cropper-container img{backface-visibility:hidden;display:block;height:100%;image-orientation:0deg;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;width:100%}.cropper-canvas,.cropper-crop-box,.cropper-drag-box,.cropper-modal,.cropper-wrap-box{bottom:0;left:0;position:absolute;right:0;top:0}.cropper-canvas,.cropper-wrap-box{overflow:hidden}.cropper-drag-box{background-color:#fff;opacity:0}.cropper-modal{background-color:#000;opacity:.5}.cropper-view-box{display:block;height:100%;outline:1px solid #39f;outline-color:rgba(51,153,255,.75);overflow:hidden;width:100%}.cropper-dashed{border:0 dashed #eee;display:block;opacity:.5;position:absolute}.cropper-dashed.dashed-h{border-bottom-width:1px;border-top-width:1px;height:33.33333%;left:0;top:33.33333%;width:100%}.cropper-dashed.dashed-v{border-left-width:1px;border-right-width:1px;height:100%;left:33.33333%;top:0;width:33.33333%}.cropper-face,.cropper-line,.cropper-point{display:block;height:100%;opacity:.1;position:absolute;width:100%}.cropper-face{background-color:#fff;left:0;top:0}.cropper-line{background-color:#39f}.cropper-line.line-e{cursor:ew-resize;right:-3px;top:0;width:5px}.cropper-line.line-n{cursor:ns-resize;height:5px;left:0;top:-3px}.cropper-line.line-w{cursor:ew-resize;left:-3px;top:0;width:5px}.cropper-line.line-s{bottom:-3px;cursor:ns-resize;height:5px;left:0}.cropper-point{background-color:#39f;height:5px;opacity:.75;width:5px}.cropper-point.point-e{cursor:ew-resize;margin-top:-3px;right:-3px;top:50%}.cropper-point.point-n{cursor:ns-resize;left:50%;margin-left:-3px;top:-3px}.cropper-point.point-w{cursor:ew-resize;left:-3px;margin-top:-3px;top:50%}.cropper-point.point-s{bottom:-3px;cursor:s-resize;left:50%;margin-left:-3px}.cropper-point.point-ne{cursor:nesw-resize;right:-3px;top:-3px}.cropper-point.point-nw{cursor:nwse-resize;left:-3px;top:-3px}.cropper-point.point-sw{bottom:-3px;cursor:nesw-resize;left:-3px}.cropper-point.point-se{bottom:-3px;cursor:nwse-resize;height:20px;opacity:1;right:-3px;width:20px}.cropper-invisible{opacity:0}.cropper-hide{display:block;height:0;position:absolute;width:0}.cropper-hidden{display:none!important}.cropper-move{cursor:move}.cropper-crop{cursor:crosshair}';
    }
    document.head.appendChild(style);

    // Pattern-Cropper-specific visual overrides (light bleed, dotted border,
    // tool-button + card styling).
    const overrides = document.createElement('style');
    overrides.textContent = PATTERN_CROPPER_OVERRIDES;
    document.head.appendChild(overrides);

    cssInjected = true;
}

function buildModal() {
    if (modalEl) return modalEl;

    const cfg = window.PATTERN_CROPPER || {};
    const raw = cfg.strings || {};
    const s = {
        back:             raw.back             || 'Înapoi',
        howItWorks:       raw.howItWorks       || 'Cum funcționează',
        dragHint:         raw.dragHint         || 'Trage imaginea pentru a o repoziționa în dreptunghiul decupajului. Proporția este blocată pe dimensiunile alese.',
        contactHelp:      raw.contactHelp      || 'Dacă nu reușești să obții decupajul 100% dorit, contactează-ne și te vom ajuta cu modificările.',
        tools:            raw.tools            || 'Instrumente',
        flipH:            raw.flipH            || 'Oglindire H',
        flipHTitle:       raw.flipHTitle       || 'Oglindire orizontală',
        flipV:            raw.flipV            || 'Oglindire V',
        flipVTitle:       raw.flipVTitle       || 'Oglindire verticală',
        grayscale:        raw.grayscale        || 'Alb-negru',
        ruler:            raw.ruler            || 'Riglă cm',
        rulerTitle:       raw.rulerTitle       || 'Afișează riglă în cm',
        silhouette:       raw.silhouette       || 'Siluetă 175 cm',
        silhouetteTitle:  raw.silhouetteTitle  || 'Adaugă siluetă 175 cm',
        reset:            raw.reset            || 'Resetează',
        confirmTitle:     raw.confirmTitle     || 'Confirmă decupajul',
        cancel:           raw.cancel           || 'Renunță',
        addToCart:        raw.addToCart        || 'Adaugă în coș',
        download:         raw.download         || 'Descarcă decupaj',
        skip:             raw.skip             || 'Adaugă în coș fără crop',
    };

    const html = `
        <div class="modal fade" id="${MODAL_ID}" tabindex="-1" aria-hidden="true" style="z-index:2000;">
          <div class="modal-dialog modal-fullscreen">
            <div class="modal-content" style="background:#f3f4f6;">
              <div class="modal-body p-0 d-flex flex-column" style="overflow-y:auto; overflow-x:hidden; -webkit-overflow-scrolling:touch;">
                <!-- Cropper stage takes most of the viewport — light wall-preview background
                     with generous padding so the dotted frame + corner diagonals + silhouette
                     never touch the modal edges.
                     flex-shrink:0 + a viewport-aware height ensures the stage never
                     squashes itself away on small phones; whatever does not fit scrolls. -->
                <div class="flex-shrink-0 px-5 py-4" style="position:relative; background:#e9ecef; overflow:hidden; height:clamp(360px, 60vh, 720px);">
                  <!-- Back / close — floats over the top-left of the cropper stage. -->
                  <button type="button" class="pc-back-btn" data-bs-dismiss="modal" aria-label="${s.back}" title="${s.back}">
                    <i class="fa-sharp fa-regular fa-arrow-left"></i>
                  </button>
                  <div id="${MODAL_ID}-stage" style="position:relative; width:100%; height:100%; max-width:1320px; margin:0 auto;">
                    <!-- crossOrigin so we can later read the cropped pixels
                         via getCroppedCanvas → toBlob for the Download feature.
                         The image CDN must respond with
                         Access-Control-Allow-Origin: * for this to succeed. -->
                    <img id="${MODAL_ID}-img" alt="pattern" crossorigin="anonymous" style="display:block; max-width:100%;"/>
                  </div>
                </div>

                <!-- Controls area: three cards below the cropper -->
                <div class="px-5 py-4 bg-white" style="border-top:1px solid #e5e7eb; flex-shrink:0;">
                  <div class="row align-items-stretch pc-cards-row" style="--bs-gutter-x: 48px; --bs-gutter-y: 24px;">
                    <!-- How-it-works (+ contact help) -->
                    <div class="col-md-4">
                      <div class="pc-card d-flex flex-column">
                        <div class="pc-card-label">
                          <i class="fa-sharp fa-regular fa-circle-info" style="color:#7c3aed;"></i>
                          ${s.howItWorks}
                        </div>
                        <p class="mb-0" style="font-size:12px; line-height:1.55; color:#4b5563;">
                          ${s.dragHint}
                          (<strong data-pc-dims style="color:#374151;">—</strong>).
                        </p>
                        <hr style="margin:14px 0; border-color:#e5e7eb;"/>
                        <div data-pc-contact-help style="font-size:11px; line-height:1.5; color:#6b7280;">
                          <i class="fa-sharp fa-regular fa-circle-question" style="color:#7c3aed;"></i>
                          ${s.contactHelp}
                          <span data-pc-contact-links></span>
                        </div>
                      </div>
                    </div>

                    <!-- Tools — vertical stack with label to the right of each button -->
                    <div class="col-md-4">
                      <div class="pc-card">
                        <div class="pc-card-label">
                          <i class="fa-sharp fa-regular fa-sliders" style="color:#7c3aed;"></i>
                          ${s.tools}
                        </div>
                        <div class="pc-tool-list">
                          <button type="button" class="pc-tool-row" data-pc-flip="h" title="${s.flipHTitle}">
                            <span class="pc-tool-btn"><i class="fa-sharp fa-regular fa-arrows-left-right"></i></span>
                            <span class="pc-tool-name">${s.flipH}</span>
                          </button>
                          <button type="button" class="pc-tool-row" data-pc-flip="v" title="${s.flipVTitle}">
                            <span class="pc-tool-btn"><i class="fa-sharp fa-regular fa-arrows-up-down"></i></span>
                            <span class="pc-tool-name">${s.flipV}</span>
                          </button>
                          <button type="button" class="pc-tool-row" data-pc-grayscale title="${s.grayscale}">
                            <span class="pc-tool-btn"><i class="fa-sharp fa-regular fa-droplet-slash"></i></span>
                            <span class="pc-tool-name">${s.grayscale}</span>
                          </button>
                          <button type="button" class="pc-tool-row" data-pc-toggle-ruler title="${s.rulerTitle}">
                            <span class="pc-tool-btn"><i class="fa-sharp fa-regular fa-ruler"></i></span>
                            <span class="pc-tool-name">${s.ruler}</span>
                          </button>
                          <button type="button" class="pc-tool-row" data-pc-toggle-human title="${s.silhouetteTitle}">
                            <span class="pc-tool-btn"><i class="fa-sharp fa-regular fa-person"></i></span>
                            <span class="pc-tool-name">${s.silhouette}</span>
                          </button>
                          <button type="button" class="pc-tool-row" data-pc-reset title="${s.reset}">
                            <span class="pc-tool-btn"><i class="fa-sharp fa-regular fa-rotate-left"></i></span>
                            <span class="pc-tool-name">${s.reset}</span>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Action -->
                    <div class="col-md-4">
                      <div class="pc-card d-flex flex-column justify-content-between">
                        <div class="pc-card-label">
                          <i class="fa-sharp fa-regular fa-check" style="color:#7c3aed;"></i>
                          ${s.confirmTitle}
                        </div>
                        <div class="mt-auto">
                          <div class="d-flex gap-2 justify-content-end">
                            <button type="button" class="btn btn-gray-heavy-light fw-semibold" data-bs-dismiss="modal">${s.cancel}</button>
                            <button type="button" class="btn btn-black fw-semibold" data-pc-confirm>
                              <i class="fa-sharp fa-regular fa-check me-2"></i>${s.addToCart}
                            </button>
                          </div>
                          <div class="text-end mt-2 d-flex justify-content-end gap-3">
                            <button type="button" class="btn btn-link btn-sm p-0 text-decoration-underline" data-pc-download-crop
                                    style="font-size:11px; color:#6b7280; font-weight:500;">
                              <i class="fa-sharp fa-regular fa-download me-1"></i>${s.download}
                            </button>
                            <button type="button" class="btn btn-link btn-sm p-0 text-decoration-underline" data-pc-skip-crop
                                    style="font-size:11px; color:#6b7280; font-weight:500;">
                              ${s.skip}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>`;

    const wrap = document.createElement('div');
    wrap.innerHTML = html.trim();
    modalEl = wrap.firstElementChild;
    document.body.appendChild(modalEl);

    // Wire transform buttons
    modalEl.querySelectorAll('[data-pc-flip]').forEach((btn) => {
        btn.addEventListener('click', () => {
            if (!cropperInstance) return;
            const axis = btn.getAttribute('data-pc-flip');
            const imgData = cropperInstance.getImageData();
            if (axis === 'h') {
                cropperInstance.scaleX(-1 * (imgData.scaleX || 1));
            } else {
                cropperInstance.scaleY(-1 * (imgData.scaleY || 1));
            }
            btn.classList.toggle('active');
        });
    });

    modalEl.querySelector('[data-pc-grayscale]').addEventListener('click', (e) => {
        const btn = e.currentTarget;
        btn.classList.toggle('active');
        const isGrayscale = btn.classList.contains('active');
        // Cropper.js renders TWO <img> elements: one inside .cropper-canvas
        // (the full pattern, faded behind the modal overlay) and one inside
        // .cropper-view-box (clipped to the crop selection — this is the
        // image actually visible inside the dotted box). Filter both so the
        // grayscale effect is visible in the crop preview.
        modalEl.querySelectorAll('.cropper-container img').forEach((cropperImg) => {
            cropperImg.style.filter = isGrayscale ? 'grayscale(1)' : '';
        });
        const previewImg = modalEl.querySelector(`#${MODAL_ID}-img`);
        if (previewImg) {
            previewImg.dataset.grayscale = isGrayscale ? '1' : '0';
        }
    });

    // Human silhouette toggle (175cm reference, right of the crop box).
    modalEl.querySelector('[data-pc-toggle-human]').addEventListener('click', (e) => {
        const btn = e.currentTarget;
        showHuman = !showHuman;
        btn.classList.toggle('active', showHuman);
        renderOverlays();
    });

    // Ruler toggle (cm ticks along top + right edges of the crop box).
    modalEl.querySelector('[data-pc-toggle-ruler]').addEventListener('click', (e) => {
        const btn = e.currentTarget;
        showRuler = !showRuler;
        btn.classList.toggle('active', showRuler);
        renderOverlays();
    });

    modalEl.querySelector('[data-pc-reset]').addEventListener('click', () => {
        if (!cropperInstance) return;
        cropperInstance.reset();
        // re-center the crop box + canvas (reset() resets crop selection to
        // default which may not be where we placed it on first init).
        const aspect = parseFloat(modalEl.dataset.aspect);
        if (isFinite(aspect) && aspect > 0) {
            centerCropBoxAndCanvas(cropperInstance, aspect);
        }
        // also reset flip/grayscale + overlay UI
        showHuman = false;
        showRuler = false;
        modalEl.querySelectorAll('[data-pc-flip], [data-pc-grayscale], [data-pc-toggle-human], [data-pc-toggle-ruler]').forEach((b) => {
            b.classList.remove('active');
        });
        modalEl.querySelectorAll('.cropper-container img').forEach((cropperImg) => {
            cropperImg.style.filter = '';
        });
        const previewImg = modalEl.querySelector(`#${MODAL_ID}-img`);
        if (previewImg) previewImg.dataset.grayscale = '0';
        renderOverlays();
    });

    // "Descarcă decupaj" — render the current crop (with flip + grayscale
    // baked in) and trigger a file download. File name follows the
    // product_model-WIDTHxHEIGHT.jpg convention so downloaded files map
    // back to a single product order line.
    modalEl.querySelector('[data-pc-download-crop]').addEventListener('click', () => {
        if (!cropperInstance) return;

        // Cropper bakes scaleX/scaleY (flip) into getCroppedCanvas output,
        // but CSS `filter:grayscale(1)` is NOT — that's applied to the
        // <img> on screen, not the underlying canvas. We need to re-apply
        // it manually when grayscale is active.
        const grayscaleBtn = modalEl.querySelector('[data-pc-grayscale]');
        const isGrayscale  = grayscaleBtn && grayscaleBtn.classList.contains('active');

        // Cap the output to keep memory + download size sane on phones.
        // The on-screen preview is much smaller than the source image
        // anyway — 4096px on the longest side is plenty for a wall print
        // reference. The supplier still gets the real high-res crop from
        // the server-rendered preview saved at order time.
        let cropped;
        try {
            cropped = cropperInstance.getCroppedCanvas({
                maxWidth: 4096,
                maxHeight: 4096,
                imageSmoothingEnabled: true,
                imageSmoothingQuality: 'high',
                fillColor: '#ffffff',
            });
        } catch (err) {
            console.error('[pattern-cropper] getCroppedCanvas failed:', err);
            alert('Nu am putut genera fișierul. Te rugăm să contactezi suportul.');
            return;
        }
        if (!cropped) return;

        let outCanvas = cropped;
        if (isGrayscale) {
            outCanvas = document.createElement('canvas');
            outCanvas.width  = cropped.width;
            outCanvas.height = cropped.height;
            const ctx = outCanvas.getContext('2d');
            // Try the built-in CSS filter first — fastest path; falls back
            // to a per-pixel desaturation if the browser doesn't support
            // canvas filters (very old Safari).
            if ('filter' in ctx) {
                ctx.filter = 'grayscale(1)';
                ctx.drawImage(cropped, 0, 0);
                ctx.filter = 'none';
            } else {
                ctx.drawImage(cropped, 0, 0);
                const img  = ctx.getImageData(0, 0, outCanvas.width, outCanvas.height);
                const data = img.data;
                for (let i = 0; i < data.length; i += 4) {
                    // ITU-R BT.709 luminance coefficients
                    const lum = 0.2126 * data[i] + 0.7152 * data[i + 1] + 0.0722 * data[i + 2];
                    data[i] = data[i + 1] = data[i + 2] = lum;
                }
                ctx.putImageData(img, 0, 0);
            }
        }

        // Build the filename. Sanitise the model to a safe filesystem string.
        const cfg = window.PATTERN_CROPPER || {};
        const rawModel = String(cfg.productModel || 'crop').trim();
        const safeModel = rawModel.replace(/[^A-Za-z0-9._-]+/g, '_').replace(/^_+|_+$/g, '') || 'crop';
        const widthCm  = parseInt(modalEl.dataset.widthCm  || '0', 10) || 0;
        const heightCm = parseInt(modalEl.dataset.heightCm || '0', 10) || 0;
        const filename = `${safeModel}-${widthCm}x${heightCm}.jpg`;

        try {
            outCanvas.toBlob((blob) => {
                if (!blob) return;
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
                setTimeout(() => {
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }, 200);
            }, 'image/jpeg', 0.92);
        } catch (err) {
            // SecurityError — canvas tainted by cross-origin image without CORS.
            // The image CDN needs to send Access-Control-Allow-Origin.
            console.error('[pattern-cropper] toBlob failed:', err);
            alert('Nu am putut descărca fișierul. Te rugăm să contactezi suportul.');
        }
    });

    // "Adaugă în coș fără crop" — skip the cropper entirely and add the
    // product as a regular cart line (no crop_data, no oc_order_product_crop
    // row at checkout). Used by customers who decide the default pattern
    // framing is fine and don't need to customise.
    modalEl.querySelector('[data-pc-skip-crop]').addEventListener('click', () => {
        const hidden = document.getElementById('input-crop-data');
        if (hidden) hidden.value = '';

        // Blur + hide the modal (avoids the aria-hidden focus warning).
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
            document.activeElement.blur();
        }
        const inst = window.bootstrap && window.bootstrap.Modal
            ? window.bootstrap.Modal.getOrCreateInstance(modalEl)
            : null;
        if (inst) inst.hide();

        // Resolve the pending modal-promise with null so the capture-phase
        // wrapper's `.then(payload)` runs the null-branch (releases its
        // `busy` flag, doesn't fire its own cart-add). We fire the cart-add
        // ourselves below.
        if (resolveFn) {
            const fn = resolveFn;
            resolveFn = null;
            fn(null);
        }

        // Fire the standard cart-add. Our capture-phase listener on
        // #button-cart only triggers on user CLICKS, not programmatic calls,
        // so this bypasses the cropper modal entirely.
        if (typeof window.productCartAdd === 'function') {
            window.productCartAdd();
        }
    });

    modalEl.querySelector('[data-pc-confirm]').addEventListener('click', () => {
        if (!cropperInstance) return;
        const data = cropperInstance.getData(false); // floating
        const canvas = cropperInstance.getCanvasData();
        const imgData = cropperInstance.getImageData();
        const naturalW = imgData.naturalWidth || canvas.naturalWidth;
        const naturalH = imgData.naturalHeight || canvas.naturalHeight;

        if (!naturalW || !naturalH) {
            return;
        }

        // Cropper getData returns pixel coords on the natural image
        const cx = Math.max(0, Math.min(1, data.x / naturalW));
        const cy = Math.max(0, Math.min(1, data.y / naturalH));
        const cw = Math.max(0.0001, Math.min(1 - cx, data.width / naturalW));
        const ch = Math.max(0.0001, Math.min(1 - cy, data.height / naturalH));

        const flipBtnH = modalEl.querySelector('[data-pc-flip="h"]');
        const flipBtnV = modalEl.querySelector('[data-pc-flip="v"]');
        const grayBtn  = modalEl.querySelector('[data-pc-grayscale]');

        const payload = {
            x: +cx.toFixed(4),
            y: +cy.toFixed(4),
            w: +cw.toFixed(4),
            h: +ch.toFixed(4),
            flipH: flipBtnH && flipBtnH.classList.contains('active'),
            flipV: flipBtnV && flipBtnV.classList.contains('active'),
            grayscale: grayBtn && grayBtn.classList.contains('active'),
        };

        // Blur the active element BEFORE hiding — Bootstrap sets aria-hidden
        // on the modal during the hide transition, and browsers warn (rightly)
        // if aria-hidden contains a focused descendant.
        if (document.activeElement && typeof document.activeElement.blur === 'function') {
            document.activeElement.blur();
        }

        // hide modal first, then resolve so caller can proceed with cart-add
        const inst = window.bootstrap && window.bootstrap.Modal
            ? window.bootstrap.Modal.getOrCreateInstance(modalEl)
            : null;
        if (inst) inst.hide();
        if (resolveFn) {
            const fn = resolveFn;
            resolveFn = null;
            fn(payload);
        }
    });

    // Blur any focused element inside the modal as it starts hiding, so the
    // a11y warning about aria-hidden + focused descendant doesn't fire.
    modalEl.addEventListener('hide.bs.modal', () => {
        if (modalEl.contains(document.activeElement)
            && typeof document.activeElement.blur === 'function') {
            document.activeElement.blur();
        }
    });

    modalEl.addEventListener('hidden.bs.modal', () => {
        if (cropperInstance) {
            cropperInstance.destroy();
            cropperInstance = null;
        }
        // Reset transform + overlay UI state for next open
        showHuman = false;
        showRuler = false;
        modalEl.querySelectorAll('[data-pc-flip], [data-pc-grayscale], [data-pc-toggle-human], [data-pc-toggle-ruler]').forEach((b) => {
            b.classList.remove('active');
        });
        const overlayLayer = modalEl.querySelector('[data-pc-overlay-layer]');
        if (overlayLayer) overlayLayer.innerHTML = '';
        // If user closed without confirming, resolve null to release any waiters
        if (resolveFn) {
            const fn = resolveFn;
            resolveFn = null;
            fn(null);
        }
    });

    // Populate the contact-us help line with phone / email from
    // window.PATTERN_CROPPER. Runs once at first modal build.
    const cfgForHelp = window.PATTERN_CROPPER || {};
    const linksHost  = modalEl.querySelector('[data-pc-contact-links]');
    if (linksHost) {
        const parts = [];
        if (cfgForHelp.contactPhone) {
            const phone = String(cfgForHelp.contactPhone).trim();
            const tel   = phone.replace(/[^+\d]/g, '');
            parts.push('<a href="tel:' + tel + '" style="color:#7c3aed; font-weight:600; white-space:nowrap;">'
                + '<i class="fa-sharp fa-regular fa-phone"></i> ' + phone + '</a>');
        }
        if (cfgForHelp.contactEmail) {
            const email = String(cfgForHelp.contactEmail).trim();
            parts.push('<a href="mailto:' + email + '" style="color:#7c3aed; font-weight:600; white-space:nowrap;">'
                + '<i class="fa-sharp fa-regular fa-envelope"></i> ' + email + '</a>');
        }
        if (parts.length) {
            linksHost.innerHTML = ' &mdash; ' + parts.join(' &nbsp;sau&nbsp; ');
        }
    }

    return modalEl;
}

/**
 * Pin the crop box to a fixed rectangle centered in the cropper container,
 * with aspect ratio = wall_width_cm / wall_height_cm, then size + center the
 * pattern image (canvas) so the image height matches the crop-box height.
 * After this, dragging moves the canvas (image) behind the static crop box,
 * which the customer uses to choose the horizontal slice (and vertical, if
 * the image happens to be taller than the box).
 */
function centerCropBoxAndCanvas(cropper, aspect) {
    if (!cropper) return;
    const container = cropper.getContainerData();
    if (!container || !container.width || !container.height) return;

    // Crop box dimensions: 60% of the height / 60% of the width. Leaves
    // enough margin around the box that the corner diagonals (~60px out
    // of each corner) AND the cm dimension pills (top + left rotated)
    // never get clipped by the stage edges, even for extreme aspects
    // like a 200x600 wall (tall narrow box) or 600x200 (wide short box).
    const maxH = container.height * 0.60;
    const maxW = container.width * 0.60;
    let boxH = maxH;
    let boxW = boxH * aspect;
    if (boxW > maxW) {
        boxW = maxW;
        boxH = boxW / aspect;
    }
    const boxLeft = (container.width - boxW) / 2;
    const boxTop  = (container.height - boxH) / 2;

    // Canvas (image) dimensions: match the crop box on ONE axis exactly so
    // the bleed only ever appears on the two perpendicular sides:
    //   * pattern aspect > crop aspect (pattern wider than the wall) →
    //     image height = box height, overflows left + right
    //   * pattern aspect < crop aspect (pattern narrower than the wall) →
    //     image width  = box width,  overflows top + bottom
    //   * equal → exact fit, no bleed
    const imgData = cropper.getImageData();
    const naturalW = imgData.naturalWidth;
    const naturalH = imgData.naturalHeight;
    if (!naturalW || !naturalH) return;

    const patternAspect = naturalW / naturalH;
    const cropAspect    = boxW / boxH;
    const scale = (patternAspect > cropAspect)
        ? (boxH / naturalH)
        : (boxW / naturalW);
    const canvasW = naturalW * scale;
    const canvasH = naturalH * scale;

    // ORDER MATTERS — Cropper.js cross-clamps box vs canvas in BOTH
    // directions:
    //   * setCropBoxData clamps the box max to fit the current canvas
    //     (renderCropBox → limitCropBox)
    //   * setCanvasData clamps the canvas MIN to cover the current cropbox
    //     (renderCanvas → limitCanvas with imgAspectRatio applied)
    //   * setCanvasData ALSO clamps the canvas POSITION to keep the cropbox
    //     inside it — the position window depends on where the cropbox
    //     currently is. So a placeholder at (0,0) would force the canvas
    //     to (0,0) too, not where we want it.
    //
    // Three-step dance:
    //   1. Cropbox = tiny placeholder POSITIONED at the container center —
    //      collapses minCanvas size to ~0 AND lets the canvas position
    //      window straddle the container centre.
    //   2. Canvas = intended size at the container centre.
    //   3. Cropbox = intended size + position (now within the larger
    //      canvas so no maxCropBox clamp).
    const cx = container.width  / 2;
    const cy = container.height / 2;
    cropper.setCropBoxData({ left: cx - 0.5, top: cy - 0.5, width: 1, height: 1 / aspect });
    cropper.setCanvasData({
        left: (container.width - canvasW) / 2,
        top:  (container.height - canvasH) / 2,
        width: canvasW,
        height: canvasH,
    });
    cropper.setCropBoxData({ left: boxLeft, top: boxTop, width: boxW, height: boxH });
}

function readAspectRatio() {
    const cfg = window.PATTERN_CROPPER || {};
    let w = 0;
    let h = 0;
    if (cfg.widthOptionId) {
        const el = document.getElementById('input-option' + cfg.widthOptionId);
        if (el) w = parseFloat(el.value || el.getAttribute('value') || '0') || 0;
    }
    if (cfg.heightOptionId) {
        const el = document.getElementById('input-option' + cfg.heightOptionId);
        if (el) h = parseFloat(el.value || el.getAttribute('value') || '0') || 0;
    }
    return { w, h };
}

/**
 * Open the cropper modal. Resolves with payload on confirm, or null if cancelled.
 */
window.openPatternCropper = function openPatternCropper() {
    return new Promise((resolve) => {
        const cfg = window.PATTERN_CROPPER || {};
        if (!cfg.enabled || !cfg.patternImage) {
            resolve(null);
            return;
        }

        const { w, h } = readAspectRatio();
        const aspect = (w > 0 && h > 0) ? (w / h) : NaN;

        injectCss();
        buildModal();
        resolveFn = resolve;

        // populate dims label
        const dimsLabel = modalEl.querySelector('[data-pc-dims]');
        if (dimsLabel) dimsLabel.textContent = (w && h) ? (w + ' × ' + h + ' cm') : 'liber';

        // Load image AND wait for modal to be fully shown before initializing Cropper.
        // Cropper measures the <img>'s container at init time — if the modal is still
        // mid-transition (display:none → block + fade) the box is zero-sized and the
        // crop area renders tiny. We gate init behind both signals.
        const img = modalEl.querySelector('#' + MODAL_ID + '-img');
        img.dataset.grayscale = '0';

        let imageLoaded = false;
        let modalShown  = false;

        const tryInit = () => {
            if (!imageLoaded || !modalShown) return;
            if (cropperInstance) {
                try { cropperInstance.destroy(); } catch (e) { /* noop */ }
                cropperInstance = null;
            }
            cropperInstance = new Cropper(img, {
                aspectRatio: aspect,
                // viewMode 1 natively prevents the user from dragging the
                // canvas off the crop box — Cropper itself stops the pan at
                // the boundary instead of allowing free movement and then
                // snapping back. The axis where canvas == box is fully
                // locked; the perpendicular axis (where canvas is bigger
                // than box) pans freely within the slack.
                viewMode: 1,
                dragMode: 'move',   // dragging moves the IMAGE (canvas), not the crop box
                autoCropArea: 1,
                background: false,
                // responsive:false — modal is fixed-size while open. With
                // responsive:true Cropper would re-fit canvas-to-cover-container
                // on resize (fired during modal-fullscreen transition),
                // overriding our custom centerCropBoxAndCanvas sizing.
                responsive: false,
                checkOrientation: false,
                movable: true,      // image is freely movable behind the crop
                rotatable: false,
                scalable: true,
                zoomable: false,
                // Crop box stays put — fixed rectangle in the center.
                cropBoxMovable: false,
                cropBoxResizable: false,
                ready: function () {
                    centerCropBoxAndCanvas(cropperInstance, aspect);
                    renderOverlays();
                },
                crop: function () {
                    // Fires whenever the canvas (image) moves behind the
                    // fixed crop box — keep overlays glued to the box.
                    renderOverlays();
                },
            });
        };

        img.onload = () => { imageLoaded = true; tryInit(); };
        img.onerror = () => {
            if (resolveFn) {
                const fn = resolveFn;
                resolveFn = null;
                fn(null);
            }
        };
        img.src = cfg.patternImage + ((cfg.patternImage.indexOf('?') >= 0) ? '&' : '?') + 't=' + Date.now();

        // ship width_cm / height_cm into the payload via dataset for the confirm handler
        // in mm-mode convert to cm so downstream (crop thumbnail, order model) always gets cm
        const _dimUnit = (cfg.dimUnit) || 'cm';
        const _toCm = _dimUnit === 'mm' ? 10 : 1;
        modalEl.dataset.widthCm   = String(w / _toCm);
        modalEl.dataset.heightCm  = String(h / _toCm);
        modalEl.dataset.widthRaw  = String(w);
        modalEl.dataset.heightRaw = String(h);
        modalEl.dataset.dimUnit   = _dimUnit;
        modalEl.dataset.aspect    = String(aspect);

        // Show
        const inst = window.bootstrap && window.bootstrap.Modal
            ? window.bootstrap.Modal.getOrCreateInstance(modalEl)
            : null;

        const onShown = () => {
            modalEl.removeEventListener('shown.bs.modal', onShown);
            modalShown = true;
            tryInit();
        };
        modalEl.addEventListener('shown.bs.modal', onShown);

        if (inst) {
            inst.show();
        } else {
            // No Bootstrap — fall back to assuming the modal is visible immediately
            modalShown = true;
            tryInit();
        }
    });
};

/**
 * Hijack the #button-cart click in the CAPTURE phase so we run before
 * the inline onclick="productCartAdd()" handler. If cropper is enabled
 * and no crop has been confirmed yet, we stop propagation, open the
 * modal, and only after confirm do we let the cart-add proceed.
 *
 * This is more robust than wrapping window.productCartAdd because the
 * wrap can be undone (e.g. by lazy-loaded modules that reassign the
 * function). A DOM click listener in capture phase always wins.
 */
(function installCartButtonHijack() {
    let busy = false;

    function doCartAddWithCrop(cropJson) {
        const hidden = document.getElementById('input-crop-data');
        if (hidden) hidden.value = cropJson;

        // Build the POST body explicitly so crop_data is guaranteed on the wire,
        // independent of jQuery's serialization of an inputs collection.
        let dataArr;
        try {
            const $inputs = window.jQuery('#product input[type=\'text\'], #product input[type=\'number\'], #product input[type=\'hidden\'], #product input[type=\'radio\']:checked, #product input[type=\'checkbox\']:checked, #product select, #product textarea');
            dataArr = $inputs.serializeArray();
        } catch (e) {
            dataArr = [];
        }
        let cropFound = false;
        for (let i = 0; i < dataArr.length; i++) {
            if (dataArr[i].name === 'crop_data') {
                cropFound = true;
                dataArr[i].value = cropJson;
            }
        }
        if (!cropFound) {
            dataArr.push({ name: 'crop_data', value: cropJson });
        }
        const dataStr = window.jQuery.param(dataArr);

        // Send directly so the response (and the cart-modal refresh) stays
        // owned by this module. Falls back to the global productCartAdd if
        // something prevents the direct ajax (e.g. jQuery not loaded).
        try {
            window.jQuery.ajax({
                url: 'index.php?route=checkout/cart/add',
                type: 'post',
                data: dataStr,
                dataType: 'json',
                success: function (json) {
                    if (json && json.success) {
                        // Același traseu ca productCartAdd: reîncărcarea lui
                        // #cart distruge elementul modalului (e înăuntru), deci
                        // trece prin helperul comun care curăță backdrop-urile.
                        window.reloadCartAndShowModal();
                    }
                },
                error: function (xhr) {
                    console.error('[pattern-cropper] cart/add error:', xhr && xhr.responseText);
                }
            });
        } catch (err) {
            console.error('[pattern-cropper] direct ajax failed, falling back to productCartAdd:', err);
            if (typeof window.productCartAdd === 'function') {
                window.productCartAdd(dataStr);
            }
        }

        // Clear hidden after a short delay so a subsequent add re-prompts
        setTimeout(() => {
            if (hidden) hidden.value = '';
            busy = false;
        }, 2500);
    }

    document.addEventListener('click', function onClick(e) {
        const target = e.target;
        if (!target || !target.closest) return;
        const btn = target.closest('#button-cart');
        if (!btn) return;

        const cfg = window.PATTERN_CROPPER || {};
        if (!cfg.enabled) return;             // feature off — let onclick run
        if (busy) {
            // Don't re-open while a previous flow is in progress
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
        }
        const hidden = document.getElementById('input-crop-data');
        if (hidden && hidden.value) return;   // already cropped — let onclick run

        // Block the inline onclick="productCartAdd()" — we'll fire it ourselves
        // after the modal confirms.
        e.preventDefault();
        e.stopImmediatePropagation();
        busy = true;

        window.openPatternCropper().then((payload) => {
            if (!payload) {
                busy = false;
                return;
            }
            payload.pattern_image = cfg.patternImage || '';
            payload.width_cm = parseFloat((modalEl && modalEl.dataset.widthCm) || '0') || 0;
            payload.height_cm = parseFloat((modalEl && modalEl.dataset.heightCm) || '0') || 0;
            doCartAddWithCrop(JSON.stringify(payload));
        }).catch((err) => {
            console.error('[pattern-cropper] modal failed:', err);
            busy = false;
        });
    }, /* useCapture = */ true);

})();
